import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* generateTeamReportSaga(action) {
    try {
        const { id } = action.payload;

        if (!id) {
            throw new Error('Report ID is required');
        }
        yield call([backendClient, backendClient.post], `reports/generate/${id}`);

        yield put(showSnackbar({
            message: 'Report generation started. It will be delivered to the specified email address shortly.',
            severity: 'success',
        }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to generate analytic team report', err?.message);
        yield put(showSnackbar({
            message: 'Failed to generate report',
            severity: 'error',
        }));
    }
}